// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Navy disc with a light ring that drains as time runs out. */
.timer {
  --timer-size: 5.5rem;
  position: relative;
  width: var(--timer-size);
  height: var(--timer-size);
  border-radius: 50%;
  background: var(--navy);
  color: var(--white);
  display: grid;
  place-items: center;
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: calc(var(--timer-size) * 0.3);
  line-height: 1;
  box-shadow: 0 4px 12px rgba(14, 36, 99, 0.3);
  flex-shrink: 0;
  transform: scale(0);
  opacity: 0;
  transition: transform 0.3s var(--bounce-effect), opacity 0.2s linear, background-color 0.3s linear;
}

.timer.go:not(.hide) {
  transform: scale(1);
  opacity: 1;
}

.timer.urgent {
  background: #c8285a;
}

.timerRing {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  transform: rotate(-90deg);
}

.timerTrack,
.timerProgress {
  fill: none;
  stroke-width: 7;
}

.timerTrack {
  stroke: rgba(255, 255, 255, 0.18);
}

.timerProgress {
  stroke: var(--sky-strong);
  stroke-linecap: round;
  transition: stroke-dashoffset 0.1s linear;
}

.timerText {
  position: relative;
  z-index: 1;
  letter-spacing: 0.5px;
}

.playerRoom .timer {
  --timer-size: 4.5rem;
}

.pause {
  position: absolute;
  right: -0.5rem;
  bottom: -0.5rem;
  display: grid;
  place-items: center;
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 50%;
  background: var(--white);
  color: var(--ink);
  font-size: 0.85rem;
  box-shadow: var(--shadow-card);
  cursor: pointer;
  z-index: 2;
}
`, "",{"version":3,"sources":["webpack://./src/browser/webapp/components/room/shared/timer.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,wCAAwC;EACxC,cAAc;EACd,4CAA4C;EAC5C,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,kGAAkG;AACpG;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,UAAU;AACZ","sourcesContent":["/* Navy disc with a light ring that drains as time runs out. */\n.timer {\n  --timer-size: 5.5rem;\n  position: relative;\n  width: var(--timer-size);\n  height: var(--timer-size);\n  border-radius: 50%;\n  background: var(--navy);\n  color: var(--white);\n  display: grid;\n  place-items: center;\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: calc(var(--timer-size) * 0.3);\n  line-height: 1;\n  box-shadow: 0 4px 12px rgba(14, 36, 99, 0.3);\n  flex-shrink: 0;\n  transform: scale(0);\n  opacity: 0;\n  transition: transform 0.3s var(--bounce-effect), opacity 0.2s linear, background-color 0.3s linear;\n}\n\n.timer.go:not(.hide) {\n  transform: scale(1);\n  opacity: 1;\n}\n\n.timer.urgent {\n  background: #c8285a;\n}\n\n.timerRing {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n  transform: rotate(-90deg);\n}\n\n.timerTrack,\n.timerProgress {\n  fill: none;\n  stroke-width: 7;\n}\n\n.timerTrack {\n  stroke: rgba(255, 255, 255, 0.18);\n}\n\n.timerProgress {\n  stroke: var(--sky-strong);\n  stroke-linecap: round;\n  transition: stroke-dashoffset 0.1s linear;\n}\n\n.timerText {\n  position: relative;\n  z-index: 1;\n  letter-spacing: 0.5px;\n}\n\n.playerRoom .timer {\n  --timer-size: 4.5rem;\n}\n\n.pause {\n  position: absolute;\n  right: -0.5rem;\n  bottom: -0.5rem;\n  display: grid;\n  place-items: center;\n  width: 1.8rem;\n  height: 1.8rem;\n  border-radius: 50%;\n  background: var(--white);\n  color: var(--ink);\n  font-size: 0.85rem;\n  box-shadow: var(--shadow-card);\n  cursor: pointer;\n  z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
